import { THERAPIES_PART_ONE } from "./part-one";
import { THERAPIES_PART_TWO } from "./part-two";
import type { Therapy, TherapyGroup } from "./types";

export * from "./types";

export const THERAPIES: Therapy[] = [...THERAPIES_PART_ONE, ...THERAPIES_PART_TWO];

export function getTherapy(slug: string): Therapy | undefined {
  return THERAPIES.find((t) => t.slug === slug);
}

/** Existing Learning Hub pages that also belong in the therapy section. */
export type ExistingTherapyCard = {
  name: string;
  abbrev?: string;
  badge: string;
  group: TherapyGroup;
  tagline: string;
  to: string;
  evidenceLabel: string;
};

export const EXISTING_THERAPY_CARDS: ExistingTherapyCard[] = [
  {
    name: "Cognitive Behavioural Therapy",
    abbrev: "CBT",
    badge: "Cognitive & Behavioural",
    group: "cognitive-behavioural",
    tagline:
      "Working with the links between thoughts, feelings and behaviour. The foundation most structured therapies build on.",
    to: "/learn/cbt",
    evidenceLabel: "Established",
  },
  {
    name: "Dialectical Behaviour Therapy",
    abbrev: "DBT",
    badge: "Skills & Regulation",
    group: "cognitive-behavioural",
    tagline:
      "Skills for overwhelming emotion, distress tolerance, mindfulness and relationships — with acceptance and change held together.",
    to: "/learn/dbt",
    evidenceLabel: "Established",
  },
  {
    name: "Internal Family Systems",
    abbrev: "IFS",
    badge: "Parts Work",
    group: "parts-compassion",
    tagline:
      "Meeting the different parts of you — protectors, exiles, firefighters — with curiosity rather than conflict.",
    to: "/learn/what-is-ifs",
    evidenceLabel: "Emerging",
  },
];

export const THERAPY_GROUP_ORDER: TherapyGroup[] = [
  "trauma-processing",
  "body-based",
  "cognitive-behavioural",
  "parts-compassion",
  "relational-depth",
];
